import { required } from "@corporate-tailwind/corp-form";
import { OrderApprovalRangeDto } from "./order-approval-range.model";

export class OrderPricingSummaryDto extends OrderApprovalRangeDto {
    subTotal: number | null = null;
    discount : number | null = null;
    total: number | null = null;
    serviceFee : number | null = null;
    isAmountAlert: boolean | null = null;
}

export class OrderPricingSummarySchema extends OrderPricingSummaryDto {
    static schema = {
        subTotal: { type: Number, builderOption: required },
        discount: { type: Number, builderOption: required },
        total: { type: Number, builderOption: required },
        serviceFee: { type: Number, builderOption: required },
        minAmount: { type: Number, builderOption: required },
        maxAmount: { type: Number, builderOption: required },
        isAmountAlert: { type: Boolean, builderOption: required }
    }
}